import { Component, Input } from '@angular/core';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { FilterListModel, FilterSubsListObj } from 'src/app/models/filter-list-model';

/**
 * Discount tier chips (shared): "DISCOUNT 50% OFF · 40% OFF · 30% OFF" while the Diwali sale is live.
 * Uses the existing offer filter (bpmOffer in the url), so it works on any beats list that reads that filter.
 * Usage: <ipm-discount-filter></ipm-discount-filter>  (on a producer page: [componentType]="'beats'" keeps the filter on that page)
 */
@Component({
  selector: 'ipm-discount-filter',
  templateUrl: './discount-filter.component.html',
  styleUrls: ['./discount-filter.component.scss'],
})
export class DiscountFilterComponent {
  /** Same as the filter section's isComponentType: set it (e.g. 'beats') to filter on the current page; empty goes to the all beats page */
  @Input() componentType: string = '';
  /** Only show these tiers (e.g. ['50', '30'] on a producer page: the tiers that producer enrolled in); null shows all */
  @Input() tiers: Array<string> | null = null;

  constructor(public commonService: CommonService) {}

  /** Discount tiers (50% / 40% / 30% off) from the offer filter */
  private get allOptions(): Array<FilterSubsListObj> {
    const offerFilter = this.commonService.filterOptionList?.find((item: FilterListModel) => item.filter_type === 'swipes-menu-bpm-offer');
    return offerFilter?.filter_sub_list || [];
  }

  /** Tiers shown as chips (limited to `tiers` when set; a selected tier always stays visible) */
  get options(): Array<FilterSubsListObj> {
    if (!this.tiers) return this.allOptions;
    return this.allOptions.filter((item: FilterSubsListObj) => item.isSelected || this.tiers!.includes(String(item.key)));
  }

  /** Select a tier; clicking the selected tier again clears it */
  onSelect(key: string | undefined): void {
    this.allOptions.forEach((item: FilterSubsListObj) => {
      item.isSelected = item.key === key ? !item.isSelected : false;
    });
    this.commonService.sendSearchDataUrl('', 'filter', this.componentType);
  }
}
